import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import ClerkApp from './ClerkApp';
import { ClerkProvider } from "@clerk/clerk-react";
import { esES, esMX, enUS } from "@clerk/localizations";
import { ConfiguracionProvider } from './context/ConfiguracionContext';
import { SucursalProvider } from './context/SucursalContext';
import { AuthProviderApi } from './context/AuthContextApi';
import { SimpleEmpresaProvider } from './hooks/useSimpleEmpresa';
import TrialGuardProvider from './components/providers/TrialGuardProvider';
import { dark, light, shadcn, simple } from "@clerk/themes";
import { revvlyClerkTheme } from './config/clerkTheme';
import './styles/clerk-overrides.css';

// Importar manejador de errores
import errorHandler from './utils/errorHandler';

// Clave pública de Clerk
const publishableKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  // <React.StrictMode> // Deshabilitado temporalmente para evitar re-renders duplicados
  <React.Fragment>
    <HelmetProvider>
      <ClerkProvider
        publishableKey={publishableKey}
        localization={esES}
        appearance={revvlyClerkTheme}
        afterSignOutUrl="/taller"
        signInForceRedirectUrl="/dashboard"
        signUpForceRedirectUrl="/dashboard"
      >
        <Router>
          <AuthProviderApi>
            <SucursalProvider>
              <SimpleEmpresaProvider>
                <TrialGuardProvider>
                  <ConfiguracionProvider>
                    <ClerkApp />
                  </ConfiguracionProvider>
                </TrialGuardProvider>
              </SimpleEmpresaProvider>
            </SucursalProvider>
          </AuthProviderApi>
        </Router>
      </ClerkProvider>
    </HelmetProvider>
  </React.Fragment>
  // </React.StrictMode>
);